var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_5950)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_5950",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 81
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 40.7495C80 18.6581 62.0914 0.749512 40 0.749512C17.9086 0.749512 0 18.6581 0 40.7495C0 62.8409 17.9086 80.7495 40 80.7495C62.0914 80.7495 80 62.8409 80 40.7495Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_5950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 0.749512H0V80.7495H80V0.749512Z",
    fill: "#0C8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3913 14.2722C65.4531 -5.63358 38.0171 -10.4713 18.1113 3.46692C-1.79453 17.4051 -6.63224 44.8411 7.30597 64.747C21.2442 84.6528 48.6802 89.4905 68.586 75.5523C88.4919 61.6141 93.3296 34.1781 79.3913 14.2722Z",
    fill: "#9E73B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6479 45.9941C29.2692 47.8205 33.6967 47.4331 37.9305 44.832",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5848 29.4643C25.3923 27.2636 23.8982 25.5966 22.2476 25.741C20.5971 25.8854 19.4151 27.7865 19.6077 29.9873C19.8002 32.188 21.2943 33.855 22.9449 33.7106C24.5954 33.5662 25.7774 31.6651 25.5848 29.4643Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8675 28.3023C38.675 26.1016 37.1809 24.4346 35.5303 24.579C33.8798 24.7234 32.6978 26.6245 32.8904 28.8252C33.0829 31.026 34.577 32.6929 36.2276 32.5485C37.8781 32.4041 39.0601 30.503 38.8675 28.3023Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_5950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.749512)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile);
export default __webpack_public_path__ + "static/media/Img_profile.a52c43cc4738decd58a82df98a03a862.svg";
export { ForwardRef as ReactComponent };